/* eslint-disable no-throw-literal */
import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { AjaxRequestMovies, MovieMode } from "../../../../Constant";
import { AJAX } from "../../../../Data/Bonus Ui/SweetAlert";

const AjaxRequestMovie = () => {
  const displayAlert = () => {
    SweetAlert.fire({
      text: 'Search for a movie. e.g. "Herry Poter".',
      input: "text",
      confirmButtonColor: "#33BFBF",
    })
      .then((name) => {
        if (name) return fetch(`https://itunes.apple.com/search?term=${name.value}&entity=movie`);
        throw null;
      })
      .then((results) => {
        return results.json();
      })
      .then((json) => {
        const movie = json.results[0];
        if (!movie) return SweetAlert.fire({ text: "No movie was found!", confirmButtonColor: "#33BFBF" });
        const name = movie.trackName;
        const imageURL = movie.artworkUrl100;
        SweetAlert.fire({
          title: "Top result:",
          imageUrl: imageURL,
          text: name,
        });
      })
      .catch((err) => {
        if (err) SweetAlert.fire("Oh noes!", "The AJAX request failed!", "error");
      });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={AjaxRequestMovies} span={AJAX} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="sweet-1" type="button" onClick={displayAlert}>
            {MovieMode}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AjaxRequestMovie;
